import { HUBSPOT_CREDITS_PAGE_REDIRECT } from 'pricing-pages-lib/constants/Gates';
import { useIsUngated } from './useIsUngated';
import { useIsPaidPortal } from '../inventory/useProductInventory';
import { useIsInAppAuth } from '../user/useUserInfo';

/**
 * Returns true when the credits page should redirect away.
 * Always true on public pages and free in-app portals.
 * For paid in-app portals, gated behind PPFE:HubspotCreditsPageRedirect.
 */
export const useHubSpotCreditsPageRedirect = () => {
  const isInApp = useIsInAppAuth();
  const {
    isPaidPortal,
    loading
  } = useIsPaidPortal();
  const isUngated = useIsUngated(HUBSPOT_CREDITS_PAGE_REDIRECT);
  if (!isInApp) {
    return true;
  }

  // Don't redirect while inventory is loading — isPaidPortal is false until
  // the query resolves, which would transiently hide the nav item for paid portals
  if (loading) {
    return false;
  }

  // Free portals always redirect
  if (!isPaidPortal) {
    return true;
  }

  // Paid in-app portals are gated
  return isUngated;
};